export default class AccessManagementService {
  constructor(accessManagementAPI, amStoreService) {
    'ngInject';
    this.api = accessManagementAPI;
    this.amStoreService = amStoreService;
  }
  getOperators() {
    return this.api.getDashboardData().then(respons => {
      const operators = respons.data.operators;
      //update the store data.
      this.amStoreService.updateOperators(operators);

      return this.amStoreService.getStore();
    });
  }
  getAssets() {
    return this.api.getDashboardData().then(respons => {
      const assets = respons.data.assets;
      //update the store.
      this.amStoreService.updateAssets(assets);

      return this.amStoreService.getStore();
    });
  }
}
